import { render, staticRenderFns } from "./Peruca.vue?vue&type=template&id=5b508ae3&"
import script from "./Peruca.vue?vue&type=script&lang=js&"
export * from "./Peruca.vue?vue&type=script&lang=js&"
import style0 from "./Peruca.vue?vue&type=style&index=0&id=5b508ae3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports